import { inject, Injectable } from '@angular/core';

import { select, Store, Action } from '@ngrx/store';

import * as fromSiteConfig from './site-config.reducer';
import * as SiteConfigActions from './site-config.actions';
import * as SiteConfigSelectors from './site-config.selectors';
import { Observable } from 'rxjs';
import { MenuItem } from 'primeng/api';

@Injectable()
export class SiteConfigFacade {

    private store: Store<fromSiteConfig.SiteConfigPartialState> = inject(Store);

    loaded$ = this.store.pipe(select(SiteConfigSelectors.getSiteConfigLoaded));
    error$ = this.store.pipe(select(SiteConfigSelectors.getSiteConfigError));
    config$ = this.store.pipe(select(SiteConfigSelectors.getSiteConfig));
    design$ = this.store.pipe(select(SiteConfigSelectors.getSiteConfigDesign));

    authenticationType$ = this.store.pipe(
        select(SiteConfigSelectors.getSiteConfigAuthenticationType)
    );
    features$ = this.store.pipe(
        select(SiteConfigSelectors.getSiteConfigFeatures)
    );
    organization$ = this.store.pipe(
        select(SiteConfigSelectors.getSiteConfigOrganization)
    );
    isMagayaNetwork$ = this.store.pipe(
        select(SiteConfigSelectors.isMagayaNetwork)
    );

    public loadSiteConfig(siteIdentifier: {
        identifier: string;
        type: 'endpoint' | 'cname';
    }) {
        this.dispatch(
            SiteConfigActions.loadSiteConfig({
                siteIdentifier,
            })
        );
    }

    public getCustomLinks(callback: (url: string) => void): Observable<MenuItem[]> {
        return this.store.pipe(select(SiteConfigSelectors.getCustomLinks(callback)));
    }

    private dispatch(action: Action) {
        this.store.dispatch(action);
    }
}
